import lead from './LeadInfo'
import additionalInfo from './AdditionalInfo'
import leadRequests from './LeadRequests'
import postPortalJson from '../../js/PortalPostJson'
import fetchPortalJson from '../../js/PortalFetchJson'
import { TO_LEAD_MODEL, TO_LEAD_ADDRESS_MODEL, TO_LEAD_CALLCENTER_MODEL } from '../../js/ModelHelpers.js'

function toConsumerModel ({ agent_id, test, subid, subid2, subid3, subid4, pub_transaction_id, dialer_session_id, agent_name, ...otherFields }) {
  return {
    consumer: {
      agent_id,
      is_test: (typeof test === 'string') && test.toUpperCase() === 'TRUE',
      subid,
      subid2,
      subid3,
      subid4,
      pub_transaction_id,
      dialer_session_id,
      agent_name
    },
    otherFields
  }
}

var jornayaScriptApplied = false
function setupJornaya (scriptUrl) {
  if (!jornayaScriptApplied) {
    var tag = document.createElement('script')
    tag.id = 'LeadiDscript_campaign'
    tag.type = 'text/javascript'
    tag.async = true
    tag.src = scriptUrl
    document.getElementsByTagName('body')[0].appendChild(tag)
    jornayaScriptApplied = true
  }
}

var trustedFormScriptApplied = false
function setupTrustedForm () {
  if (!trustedFormScriptApplied) {
    var field = 'xxTrustedFormCertUrl'
    var provideReferrer = false
    var invertFieldSensitivity = false
    var tf = document.createElement('script')
    tf.type = 'text/javascript'; tf.async = true
    tf.id = 'TrustedForm_campaign'
    tf.src = 'http' + (document.location.protocol === 'https:' ? 's' : '') +
    '://api.trustedform.com/trustedform.js?provide_referrer=' + escape(provideReferrer) + '&field=' + escape(field) + '&l=' + new Date().getTime() + Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity
    document.getElementsByTagName('body')[0].appendChild(tf)
    trustedFormScriptApplied = true
  }
}

const state = () => ({
  consumerId: null,
  currentConsumer: null,
  overlayDisclosures: null,
  overlayDisclosuresDisplayed: [],
  editingPrimaryInfo: true,
  waitingOnOffers: false,
  bulkSubmission: false,
  bulkTcpa: '',
  playTcpa: false,
  tcpaCampaign: null,
  consumerErrors: []
})

const getters = {
  consumerLoaded (state) {
    return state.consumerId && state.consumerId > 0
  },
  allowConsumerInfoEdit (state, getters) {
    return getters['leadRequests/getRequests'].length < 1
  },
  hasDisplayedOverlayDisclosure: (state) => (disclosureType) => {
    return state.overlayDisclosuresDisplayed.some((t) => t === disclosureType)
  },
  useBulkSubmission (state) {
    return state.bulkSubmission
  },
  hasPlayTcpa (state) {
    return state.playTcpa
  },
  tcpaCampaign (state) {
    return state.tcpaCampaign
  }
}

const actions = {
  async createConsumer ({ dispatch, commit }, consumerInfo) {
    commit('clearConsumerErrors')
    var consumerModel = toConsumerModel(consumerInfo.prepop)
    consumerModel.consumer.portal_code = consumerInfo.portalCode
    consumerModel.consumer.partner_code = consumerInfo.portalCode
    var consumerResponse
    try {
      consumerResponse = await postPortalJson('consumers', { consumer: consumerModel.consumer })
    } catch {
      commit('addConsumerError', 'Invalid Portal Code')
      return
    }
    if (Object.keys(consumerResponse.consumer.errors).length) {
      for (var fieldError in consumerResponse.consumer.errors) {
        commit('addConsumerError', Array.isArray(consumerResponse.consumer.errors[fieldError]) ? consumerResponse.consumer.errors[fieldError][0] : consumerResponse.consumer.errors[fieldError])
      }
      commit('setCurrentConsumer', consumerResponse.consumer)
      return
    }
    var leadModel = TO_LEAD_MODEL(consumerModel.otherFields)
    leadModel.lead.source_service_leadid = leadModel.lead.service_leadid
    leadModel.lead.service_leadid = null
    leadModel.lead.test = consumerModel.consumer.isTest
    if (consumerModel.consumer.agent_name) {
      leadModel.lead.agent_name = consumerModel.consumer.agent_name
    }
    var yearRegex = /^\d{4}$/
    var monthDayRegex = /^\d{2}-\d{2}$/
    if (yearRegex.test(leadModel.lead.dob)) {
      var dobYear = parseInt(leadModel.lead.dob)
      var currentYear = (new Date()).getFullYear()
      var yearDiff = currentYear - dobYear
      if (yearDiff < 85 && yearDiff > 17) {
        leadModel.lead.birthYear = dobYear
      }
    } else if (monthDayRegex.test(leadModel.lead.dob)) {
      var monthDay = leadModel.lead.dob.split('-')
      var dobDay = parseInt(monthDay[1])
      var dobMonth = parseInt(monthDay[0])
      if (dobDay < 32) {
        leadModel.lead.birthDay = dobDay
      }
      if (dobMonth < 13) {
        leadModel.lead.birthMonth = dobMonth
      }
    } else if (leadModel.lead.dob) {
      var birthDate = new Date(leadModel.lead.dob)
      if (!isNaN(birthDate.getTime())) {
        leadModel.lead.birthDay = birthDate.getUTCDate()
        leadModel.lead.birthMonth = birthDate.getUTCMonth() + 1
        leadModel.lead.birthYear = birthDate.getUTCFullYear()
      }
    }
    var leadAddress = TO_LEAD_ADDRESS_MODEL(leadModel.otherFields)
    if (!leadModel.lead.ip || leadModel.lead.ip === '') {
      leadModel.lead.ip = consumerResponse.consumer.client_ip
    }
    var leadCallCenter = TO_LEAD_CALLCENTER_MODEL(leadAddress.otherFields)
    setupJornaya(consumerResponse.consumer.leadid_reset_script)
    setupTrustedForm()
    commit('lead/setState', leadModel.lead)
    commit('lead/setState', leadAddress.address)
    commit('lead/setState', leadCallCenter.callcenter)
    commit('setCurrentConsumer', consumerResponse.consumer)
    await dispatch('getAdditionalQuestions', leadCallCenter.otherFields)
    commit('setOverlayDisclosure', consumerResponse.overlay_disclosures)
  },
  async retrieveConsumer ({ dispatch, commit, state }, consumerId) {
    if (consumerId === `${state.consumerId}`) {
      return
    }
    commit('clearConsumerErrors')
    var consumerResponse = null
    try {
      consumerResponse = await fetchPortalJson(`consumers/${consumerId}`)
    } catch (e) {
      e.errors.forEach((e) => commit('addConsumerError', e))
      return
    }
    if (consumerResponse.leads && consumerResponse.leads.length > 0) {
      var leadData = { lead: consumerResponse.leads[0], address: consumerResponse.lead_addresses[0] }
      await dispatch('lead/loadData', leadData)

      if (leadData.lead.service_leadid) {
        // Setup Jornaya non-Reset script
        document.getElementById('leadid_token').value = leadData.lead.service_leadid
        setupJornaya(consumerResponse.consumer.leadid_script)
      } else {
        setupJornaya(consumerResponse.consumer.leadid_reset_script)
      }
      setupTrustedForm()
    }
    commit('lead/setState', { agent_name: consumerResponse.consumer.agent_name })
    await dispatch('leadRequests/loadPreviousLeadRequests', { consumerId, maxSubmits: consumerResponse.consumer.max_offer_submission })
    // load other data here
    commit('setCurrentConsumer', consumerResponse.consumer)
    await dispatch('getAdditionalQuestions')
    if (consumerResponse.lead_educations && consumerResponse.lead_educations.length > 0) {
      await dispatch('additionalInfo/loadEducation', consumerResponse.lead_educations[0])
    }
    if (consumerResponse.lead_backgrounds && consumerResponse.lead_backgrounds.length > 0) {
      await dispatch('additionalInfo/loadBackground', consumerResponse.lead_backgrounds[0])
    }
    if (consumerResponse.leads && consumerResponse.leads.length > 0) {
      dispatch('additionalInfo/importNeededInfo', { fieldsAndValues: consumerResponse.leads[0], model: 'lead' })
    }
    if (consumerResponse.lead_addresses && consumerResponse.lead_addresses.length > 0) {
      dispatch('additionalInfo/importNeededInfo', { fieldsAndValues: consumerResponse.lead_addresses[0], model: 'lead_address' })
    }
    if (consumerResponse.lead_call_centers && consumerResponse.lead_call_centers.length > 0) {
      dispatch('additionalInfo/importNeededInfo', { fieldsAndValues: consumerResponse.lead_call_centers[0], model: 'lead_call_center' })
    }
    await dispatch('leadRequests/loadPreviousLeadRequests', { consumerId, maxSubmits: consumerResponse.consumer.max_offer_submission })
    // load other data here
    commit('setCurrentConsumer', consumerResponse.consumer)
    commit('setOverlayDisclosure', consumerResponse.overlay_disclosures)
  },
  async saveLeadInfo ({ dispatch, state }) {
    await dispatch('lead/save', state.consumerId)
    dispatch('additionalInfo/importNeededInfo', { fieldsAndValues: state.lead, model: 'lead' })
    dispatch('additionalInfo/importNeededInfo', { fieldsAndValues: state.lead, model: 'lead_address' })
    dispatch('additionalInfo/importNeededInfo', { fieldsAndValues: state.lead, model: 'lead_call_center' })
  },
  async saveAdditionalData ({ dispatch, state }) {
    if (state.lead.extraData.leadId) {
      return dispatch('additionalInfo/save', state.lead.extraData.leadId)
    }
  },
  getAdditionalQuestions ({ dispatch, state }, prepop) {
    return dispatch('additionalInfo/getQuestions', { consumerId: state.consumerId, prepop })
  }
}

const mutations = {
  setConsumerId (state, id) {
    state.consumerId = id
  },
  setCurrentConsumer (state, consumer) {
    state.currentConsumer = consumer
    state.consumerId = consumer.id
    state.bulkSubmission = consumer.use_bulk_submit
    state.playTcpa = consumer.use_play_tcpa
    state.bulkTcpa = consumer.bulk_tcpa ?? ''
    state.tcpaCampaign = consumer.tcpa_campaign
  },
  setOverlayDisclosure (state, disclosure) {
    state.overlayDisclosures = disclosure
  },
  addDisplayedDisclosure (state, disclosureType) {
    state.overlayDisclosuresDisplayed.push(disclosureType)
  },
  addConsumerError (state, error) {
    var updatedErrors = [...state.consumerErrors]
    updatedErrors.push(error)
    state.consumerErrors = updatedErrors
  },
  clearConsumerErrors (state) {
    state.consumerErrors = []
  },
  setEditingPrimaryInfo (state, editing) {
    state.editingPrimaryInfo = editing
  },
  waitOnOffers (state) {
    state.waitingOnOffers = true
  },
  endWaitOnOffers (state) {
    state.waitingOnOffers = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    lead,
    additionalInfo,
    leadRequests
  }
}
